export const fetchAds = async (payload) => {
    // console.log('fetchAds', payload);
    try {
        const res = await axios.get('/cta-setta-3000', { params: payload });
        return res.data;
    } catch (e) {
        throw e;
    }
};
